const ST4_odds_old = [
  {
    product1: "A",
    d_level: "option1",
    product: "P",
  },
  {
    product1: "A",
    d_level: "option2",
    product: "P",
  },
  {
    product1: "A",
    d_level: "option3",
    product: "P",
  },
  {
    product1: "B",
    d_level: "option1",
    product: "P",
  },
  {
    product1: "B",
    d_level: "option2",
    product: "P",
  },
  {
    product1: "B",
    d_level: "option3",
    product: "Q",
  },
  {
    product1: "C",
    d_level: "option1",
    product: "P",
  },
  {
    product1: "C",
    d_level: "option2",
    product: "Q",
  },
  {
    product1: "C",
    d_level: "option3",
    product: "Q",
  },
  {
    product1: "D",
    d_level: "option1",
    product: "Q",
  },
  {
    product1: "D",
    d_level: "option2",
    product: "Q",
  },
  {
    product1: "D",
    d_level: "option3",
    product: "Q",
  },
];
export default ST4_odds_old;
